<template>
  <div class="tabs-container ng-scope" style="padding-bottom: 50px; margin-top: 18px">
    <el-form :model="user" ref="user" label-width="0px" class="demo-dynamic form-horizontal detailPage">
      <div class="tab-content">
        <div>
          <div class="panel-body">
            <div class="ibox-content">
              <div class="form-group">
                <label class="col-sm-2 control-label">
                  Username
                  <span style="color: red">*</span>
                </label>
                <div class="col-sm-10">
                  <el-form-item prop="userName" :rules="[
                    {
                      required: true,
                      message: $t('message.required'),
                      trigger: 'blur',
                    },
                    {
                      pattern: /^[a-zA-Z0-9 !#$'()*+,./:;=?@\\^_`~-]{6,50}$/,
                      message: 'Min. 6 characters',
                    },
                  ]">
                    <el-input v-model="user.userName" :name="'userName'" maxLength="50" />
                  </el-form-item>
                </div>
              </div>
              <div class="form-group">
                <label class="col-sm-2 control-label">
                  {{ $t("message.password") }}
                  <span v-if="!$route.query.id" style="color: red">*</span>
                </label>
                <div class="col-sm-10">
                  <el-form-item prop="password" :rules="[
                    {
                      required: $route.query.id ? false : true,
                      message: $t('message.required'),
                      trigger: 'blur',
                    },
                    {
                      pattern: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[^]{8,16}$/,
                      message:
                        'Please enter a password in the correct format',
                    },
                  ]">
                    <el-input type="password" v-model.trim="user.password" autocomplete="off" show-password
                      :name="'pwd'" />
                    <div class="passwordFormat">
                      {{ $t("message.passwordFormat") }}
                    </div>
                  </el-form-item>
                </div>
              </div>
              <div class="form-group">
                <label class="col-sm-2 control-label">
                  Real Name
                  <span style="color: red">*</span>
                </label>
                <div class="col-sm-10">
                  <el-form-item prop="realName" :rules="[
                    {
                      required: true,
                      message: $t('message.required'),
                      trigger: 'blur',
                    },
                  ]">
                    <el-input v-model="user.realName" :name="'realName'" />
                  </el-form-item>
                </div>
              </div>
              <div class="form-group">
                <label class="col-sm-2 control-label">
                  {{ $t("message.email") }}
                  <!-- <span style="color: red">*</span> -->
                </label>
                <div class="col-sm-10">
                  <el-form-item prop="email" :rules="[
                    {
                      required: false,
                      message: $t('message.required'),
                      trigger: 'blur',
                    },
                    {
                      type: 'email',
                      message: 'Please input the correct email address',
                      trigger: ['blur', 'change'],
                    },
                  ]">
                    <el-input type="email" v-model.trim="user.email" :name="'email'" />
                  </el-form-item>
                </div>
              </div>
              <div class="form-group">
                <label class="col-sm-2 control-label">
                  District
                </label>
                <div class="col-sm-10">
                  <el-form-item :prop="'districtCode'" :rules="{
                    required: true,
                    message: $t('message.required'),
                    trigger: 'blur'
                  }">
                    <el-select v-model="user.districtCode" placeholder="District" clearable>
                      <el-option v-for="item in districtGetlist" :key="item.districtCode"
                        :label="item.districtNameEn" :value="item.districtCode">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </div>
              </div>
              <div class="form-group">
                <label class="col-sm-2 control-label">
                  {{ $t("message.Status") }}
                  <span style="color: red">*</span>
                </label>
                <div class="col-sm-3">
                  <el-form-item prop="status" :rules="{
                    required: true,
                    message: $t('message.required'),
                    trigger: 'change',
                  }">
                    <el-select clearable v-model="user.status" name="status">
                      <el-option v-for="item in statusObj" :key="item.value" :label="item.label"
                        :value="item.value"></el-option>
                    </el-select>
                  </el-form-item>
                </div>
              </div>
              <div class="hr-line-dashed"></div>
              <div class="form-group">
                <div class="col-sm-12">
                  <div class="pull-right">
                    <el-button type="primary" v-if="(checkPermission('STAFF_ACCOUNT_LIST_EDIT') &&
                      $route.query.id) ||
                      (checkPermission('STAFF_ACCOUNT_LIST_ADD') && !$route.query.id)
                      " @click="checkEvent()">
                      {{ $t("message.Save") }}
                    </el-button>
                    <el-button @click="showWarning()">
                      {{ $t("message.Cancel") }}
                    </el-button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-form>
  </div>
</template>
<script>
import config from "../config";
import sha256 from "sha256";

export default {
  mixins: [config.globalMixin],
  data() {
    return {
      user: {
        "userName": "",
        "password": "",
        "status": 1,
        "email": "",
        "realName": "",
        "districtCode": ''
      },
      districtGetlist: [],
      statusObj: [],
    };
  },
  created() {
    this.init();
    this.getDistrictGetlist();
  },
  mounted() { },
  methods: {
    async init() {
      let id = this.$route.query.id;
      if (id) {
        let obj = this.getAuthObj();
        obj.id = id;
        obj.apiUrl = this.apiConfig.staffUserDetail;
        let data = await this.$store.dispatch("apiEvent", obj);
        if (data == "000104") {
          this.timeoutEvent();
          return;
        }
        if (!data) return;
        this.$set(this, "user", data.data.result);
      } else {
        let initUser = {
          id: null,
          password: "",
          userName: "",
          email: "",
          status: "",
          realName: "",
        };
        this.$set(this, "user", initUser);
      }
      if (this.user.status == 2) {
        this.user.status = 1
      }
      this.statusObj = [
        {
          value: 1,
          label: this.$i18n.t("message.Active"),
        },
        {
          value: 0,
          label: this.$i18n.t("message.Inactive"),
        },
      ];
    },
    async getDistrictGetlist() {
      let obj = this.getAuthObj();
      obj.apiUrl = this.apiConfig.districtGetlist;
      let data = await this.$store.dispatch("apiEvent", obj);
      if (data == "000104") {
        this.timeoutEvent();
        return;
      }
      if (!data) return;
      this.$set(this, "districtGetlist", data.data.result);
    },
    showWarning(type) {
      var that = this;
      if (!type) {
        that.$router.go(-1);
      } else if (type == 1) {
      }
    },
    checkEvent() {
      this.$refs["user"].validate((valid) => {
        if (valid) {
          this.submit();
        } else {
          return false;
        }
      });
    },
    async submit() {
      let obj = this.getAuthObj();
      for (var key in this.user) {
        obj[key] = this.user[key];
      }
      if (this.user.password) {
        obj.password = sha256(this.user.password);
      }
      var data;
      if (this.$route.query.id) {
        obj.apiUrl = this.apiConfig.staffUserUpdate;
        data = await this.$store.dispatch("apiEvent", obj);
      } else {
        obj.apiUrl = this.apiConfig.staffUserCreate;
        data = await this.$store.dispatch("apiEvent", obj);
      }
      if (data == "000104") {
        this.timeoutEvent();
        return;
      }
      if (!data) return;
      if (data.data.status_code === "0") {
        this.$router.go(-1);
      }
    },
    Delete() {
      this.showWarning(1);
    },
  },
};
</script>
